module.exports = __webpack_public_path__ + "media/cheney/CheneyOffice-c0b475c3.jpg";